import React from 'react';
import {useTranslation} from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
    const {i18n} = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className="language-switcher">
            <button
                className={`lang-button ${i18n.language === 'en' ? 'active' : ''}`}
                onClick={() => changeLanguage('en')}
                title="English"
            >
                EN
            </button>
            <button
                className={`lang-button ${i18n.language === 'ru' ? 'active' : ''}`}
                onClick={() => changeLanguage('ru')}
                title="Русский"
            >
                RU
            </button>
            <button
                className={`lang-button ${i18n.language === 'uk' ? 'active' : ''}`}
                onClick={() => changeLanguage('uk')}
                title="Українська"
            >
                UK
            </button>
        </div>
    );
};

export default LanguageSwitcher;
